import Chip from '@mui/material/Chip';
import PropTypes from 'prop-types';
import { Close as CloseIcon } from '@mui/icons-material';
import styled from '@emotion/styled';
import { useContext } from 'react';
import AppContext from '../../appLayout/App.context';

const SCloseIcon = styled(CloseIcon)`
  color: inherit;
  font-weight: 600;
  height: 14px;
  width: 14px;
`;

const DeleteIconWrapper = styled.span`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  margin: 0 5px 0 -6px;
  padding: 0;
  outline-offset: 2px;
  color: ${({ disabled, theme }) => (disabled ? theme.palette.grey[60] : theme.palette.grey[100])};
  transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  &:hover {
    opacity: 0.7;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.primary.main};
    border-radius: 2px;
  }
`;

const StyledChip = styled(Chip)`
  background: ${({ theme }) => theme.palette.grey[5]};
  border: 0;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  color: ${({ disabled, theme }) => (disabled ? theme.palette.grey[60] : theme.palette.grey[100])};
  cursor: pointer;
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  font-weight: 600;
  height: 24px;
  letter-spacing: 0.1px;
  line-height: 1.5;
  margin: 5px ${({ theme }) => `${theme.spacing(4)} ${theme.spacing(1)}`} 0;
  max-width: 150px;
  overflow: hidden;
  padding: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  &:hover {
    background: ${({ theme }) => theme.palette.grey[5]};
  }
`;

export const Tag = (props) => {
  const { label = '', onDelete = () => {}, disabled } = props;
  const { t } = useContext(AppContext);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      onDelete(e);
    }
  };

  const deleteIcon = (
    <DeleteIconWrapper
      tabIndex={0}
      role="button"
      aria-label={t('Delete')}
      onKeyDown={handleKeyDown}
      disabled={disabled}
    >
      <SCloseIcon aria-hidden="true" />
    </DeleteIconWrapper>
  );

  return (
    <StyledChip
      {...props}
      aria-label={label}
      label={label}
      onDelete={onDelete}
      deleteIcon={deleteIcon}
      size="small"
      title={label}
    />
  );
};

Tag.propTypes = {
  label: PropTypes.string,
  onDelete: PropTypes.func,
  disabled: PropTypes.bool,
};
